import jQuery from 'jquery';
import Accordion from './Accordion';
import Forms from './Forms';
import cjs from './helpers/cjs';
import { Disclosure } from './helpers/shopify-cross-border';
export default class StaticFooter {
    constructor(section) {
        this.$el = jQuery(section.el);
        this.el = section.el;
        this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
        this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
        this.accordionTrigger = '[data-accordion-trigger]';
        this.disclosures = [];
        this.Accordion = new Accordion(this.el, {
            onStart: ({ el, state }) => {
                el.parentNode.parentNode.querySelector(this.accordionTrigger).dataset.accordionTrigger = state;
            },
        });
        if (cjs.max('M')) {
            this.Accordion.closeAll({
                force: true,
            });
        }
        this.forms = new Forms(this.$el);
        if (this.currencyDisclosureEl) {
            this.disclosures.push(new Disclosure(this.currencyDisclosureEl));
        }
        if (this.localeDisclosureEl) {
            this.disclosures.push(new Disclosure(this.localeDisclosureEl));
        } // Handle Accordion interaction when window size changes
        cjs.onChange((breakpoints) => this.onBreakpointChange(breakpoints));
        this._bindEvents();
    }
    _bindEvents() {
        this.$el.on('click.footer', this.accordionTrigger, (event) => {
            event.preventDefault();
            this._toggleAccordion(jQuery(event.currentTarget).parent()[0]);
        });
    }
    onSectionUnload() {
        this.$el.off('.footer');
        this.forms.unload();
        this.disclosures.forEach((disclosure) => disclosure.unload());
        this.Accordion.unload();
    }
    onSectionBlockSelect(block) {
        if (block.el.classList.contains('has-accordion'))
            this._toggleAccordion(block);
    }
    onSectionBlockDeselect(block) {
        if (block.el.classList.contains('has-accordion'))
            this._toggleAccordion(block);
    }
    _toggleAccordion(block) {
        if (cjs.min('L'))
            return;
        this.Accordion.toggle(block);
    }
    onBreakpointChange(breakpoints) {
        if (breakpoints.current.min('L')) {
            this.Accordion.openAll({
                force: true,
            });
        }
        else if (breakpoints.previous.min('L') && breakpoints.current.max('M')) {
            this.Accordion.closeAll({
                force: true,
            });
        }
    }
}
